import Account from './Account'
import {
  AccountHero,
  AccountMobile,
  AccountView,
  AccountWrapper,
} from './Account'
import AccountButtonsView from './AccountButtons'
import AccountContent from './AccountContent'
import AccountDeals from './AccountDeals'
import AccountLoyalty from './AccountLoyalty'
import AccountSlider from './AccountSlider'
import AccountWelcome from './AccountWelcome'

export {
  AccountButtonsView,
  AccountContent,
  AccountDeals,
  AccountHero,
  AccountLoyalty,
  AccountMobile,
  AccountSlider,
  AccountView,
  AccountWrapper,
  AccountWelcome,
}
export default Account
